import { CLIENT, getDeviceSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import APIAccountWebhookProvider from "Providers/APIWebhookProvider";
import React from "react";
import { Divider, Form, Header, Message, Segment } from "semantic-ui-react";

const ClientCreate = () => {
  const {
    save,
    nextExtension,
    validateExtension,
    validateName,
    validateClientUsername,
    validatePassword,
  } = useDevice();

  const initValues = {
    type: CLIENT,
    name: "",
    extension: nextExtension,
    client: {
      username: "",
      password: "",
      queues: [],
      contacts: [],
      ringTime: 180,
      maxCallTime: 14400,
      present: "pass-through",
      countryCode: "gb",
      record: false,
      onComplete: "HANGUP",
      onNoAnswer: "HANGUP",
      onFail: "HANGUP",
      onBusy: "HANGUP",
    },
  };

  return (
    <APIAccountWebhookProvider>
      <Segment>
        <Header as='h3'>Create Client</Header>
        <Divider />
        <Formik
          initialValues={initValues}
          validationSchema={getDeviceSchema(CLIENT)}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='name'
                label='Name'
                validate={validateName}
                component={CallableInput}
              />
              <Field
                name='extension'
                label='Extension'
                placeholder='100'
                type='number'
                validate={validateExtension}
                component={CallableInput}
              />
              <Field
                name='client.username'
                label='Username'
                validate={validateClientUsername}
                component={CallableInput}
              />
              <Field
                name='client.password'
                label='Password'
                type='password'
                validate={validatePassword}
                component={CallableInput}
              />

              {!isEmpty(props.errors?.client?.password) && (
                <Message size='mini' info>
                  Password Requires <br />
                  1. At least 12 Characters <br />
                  2. 1 Digit <br />
                  3. 1 Uppercase <br />
                  4. 1 Lowercase <br />
                  5. 1 Special Character
                </Message>
              )}

              <FormSubmit name='Create Client' errors={props.errors} />
            </Form>
          )}
        </Formik>
      </Segment>
    </APIAccountWebhookProvider>
  );
};

export default ClientCreate;
